import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  subcategoriescon: []
}

const mutations = {  
  SET_SUBCATEGORIES_CON (state, payload) {
    state.subcategoriescon = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  subcategoriesconList: (context, id) => {
    return Vue.http.get(`${env.API}/api/subcategory-con`)    
      .then((response) => {        
        context.commit('SET_SUBCATEGORIES_CON', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  byCategoryconId: (context, id) => {
    return Vue.http.get(`${env.API}/api/subcategory-con/by-category/${id}`)    
      .then((response) => {        
        context.commit('SET_SUBCATEGORIES_CON', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getSubcategoriescon: (state) => state.subcategoriescon
}

export const subcategorycon = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/subcategorycon.js